import React from 'react';
import PropTypes from 'prop-types';

import mergeClassName from 'merge-class-names';

import { createUseStyles, createUseColoredStyles } from '../../palette';
import decorate from '../../common/utils/decorate';

const useMainStyles = createUseStyles((theme) => ({
  tooltip: {
    ...theme.standarts('tooltip'),

    pointerEvents: 'none',

    position: 'absolute',
    zIndex: 1,

    '& > div': {
      transform: 'translateY(-100%)',
      transition: 'opacity 0.1s ease-out',
      whiteSpace: 'nowrap',
      opacity: 0,

      display: 'flex',
      flexDirection: 'column',
      boxShadow: theme.getBoxShadow('tooltip'),
      borderRadius: theme.get('tooltip', 'border.radius'),
      padding: theme.get('tooltip', 'indent'),
      gap: theme.getFactor('tooltip', 'indent', 0.5),

      position: 'relative',
      left: '-50%',
      top: -20
    }
  },

  visible: {
    '& > div': {
      opacity: 1
    }
  }
}));

const useVariantStylesMap = createUseColoredStyles((theme, color) => ({
  normal: {
    '& > div': {
      backgroundColor: theme.getColor('tooltip', color, 'value'),
      color: theme.getColor('tooltip', color, 'contrast')
    }
  }
}));

export default decorate(
  class extends React.PureComponent {
    static decorateWith = {
      classes: {
        main: useMainStyles,
        variant: useVariantStylesMap
      }
    };

    static propTypes = {
      variant: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired
    };

    static defaultProps = {
      variant: 'normal',
      color: 'basic'
    };

    constructor(props) {
      super(props);

      this.state = { isVisible: false, content: null, x: 0, y: 0 };
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const { classes, className, variant, color, onRender, ...props } =
        this.props;

      const mergedClassName = mergeClassName(
        className,
        classes.main.tooltip,
        (classes.variant[color] ?? classes.variant.basic)[variant],
        this.state.isVisible && classes.main.visible
      );

      if (typeof onRender === 'function') {
        onRender({
          showTooltip: (content, x, y) =>
            this.setState((state) => ({
              ...state,
              isVisible: true,
              content,
              x: Number(x) || 0,
              y: Number(y) || 0
            })),
          hideTooltip: () =>
            this.setState((state) => ({ ...state, isVisible: false }))
        });
      }

      return (
        <div
          {...props}
          className={mergedClassName}
          style={{ left: this.state.x, top: this.state.y }}
        >
          <div>{this.state.content}</div>
        </div>
      );
    }
  }
);
